import { useEffect, useState } from 'react';

/**
 * usePersistedState — useState that mirrors its value to localStorage.
 *
 * Falls back to the default value if storage is unavailable (e.g., private mode)
 * or the stored value can't be parsed as JSON.
 */
const usePersistedState = (key, defaultValue) => {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      return raw === null ? defaultValue : JSON.parse(raw);
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // storage unavailable — silently ignore
    }
  }, [key, value]);

  return [value, setValue];
};

export default usePersistedState;
